import { render } from "./HomeTabs.vue?vue&type=template&id=3980c34d&scoped=true"
import script from "./HomeTabs.vue?vue&type=script&lang=js"
export * from "./HomeTabs.vue?vue&type=script&lang=js"

import "./HomeTabs.vue?vue&type=style&index=0&id=3980c34d&lang=less&scoped=true"

import exportComponent from "C:\\project\\结构计算网\\famous-build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3980c34d"]])

export default __exports__